<template>
  <VView class="contest-end" back-button-to="/menu" :header="$t('contestEnd.header')">
     <VText center>{{ $t('contestEnd.content.0') }}</VText>
     <VText center small>{{ $t('contestEnd.content.1') }}</VText>
  </VView>
</template>

<script>
export default {
  name: 'ContestEnd',
};
</script>

<style lang="scss" scoped>
.contest-end {}
</style>
